module.exports = __webpack_public_path__ + "img/bg18.565a5a06.jpeg";